import { useMutation } from '@sequencehq/api/utils'
import {
  dashboardv99990101Client,
  Dashboardv99990101Api
} from '@sequencehq/api/dashboard/v99990101'
import { useNotifications } from '@sequencehq/core-components'
import { getApiErrorMessage } from 'Cube/utils/getApiErrorMessage'

type CreateCreditNoteLineItemBody =
  Dashboardv99990101Api.PostCreditNoteLineItem.CreateCreditNoteLineItemBody

export const useCreateCreditNoteLineItem = ({
  creditNoteId,
  groupId
}: {
  creditNoteId: string
  groupId: string
}) => {
  const createCreditNoteLineItemMutation = useMutation(
    dashboardv99990101Client.postCreditNoteLineItem
  )
  const { displayNotification } = useNotifications()

  return async (
    input: Omit<
      CreateCreditNoteLineItemBody,
      'creditNoteId' | 'groupId' | 'externalIds'
    >
  ): Promise<boolean> => {
    try {
      await createCreditNoteLineItemMutation.mutateAsync({
        creditNoteId,
        body: {
          creditNoteId,
          groupId,
          title: input.title,
          description: input.description,
          quantity: input.quantity,
          rate: input.rate,
          taxRate: input.taxRate,
          rateDisplay: input.rateDisplay,
          externalIds: [],
          servicePeriod: input.servicePeriod,
          revenueRecognitionMethod: input.revenueRecognitionMethod,
          productId: input.productId,
          taxCategoryId: input.taxCategoryId
        }
      })

      displayNotification('Line item added', { type: 'success' })

      return true
    } catch (error) {
      displayNotification(
        getApiErrorMessage(error, 'Failed to add line item'),
        { type: 'error' }
      )

      return false
    }
  }
}
